import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/form/contactus/Slice";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import { Button } from "react-bootstrap";
import View_Modal from "../../../common-components/common_Modal/view_Modal/View_Modal";
import View_Booking_Modal from "../../../common-components/common_Modal/View_Booking_Modal/View_Booking_Modal";
import { formatDate } from "../../../../utils/common";
import { DOWNLOAD_EXCEL } from "../../../../utils/Methods";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import View_img_Modal from "../../../common-components/common_Modal/view_img_Modal/View_img_Modal";

const Booking = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
    const [image, setImage] = React.useState("");
  const [modalImageShow, setModalImageShow] = useState(false);
  const [detailModalShow, setDetailModalShow] = useState(false);
  const [dropdetails, setDropDetails] = useState("");
  const [bookingdetails, setBookingDetails] = useState("");

 

  
  const url = new URL(window.location);

  const {
    country,
    first_name,
    setName,
    email,
    setemail,
    contact_no,
    setcontact_no,
    from,
    setFrom,
    to,
    setTo,
    fetch,
    deleteData,
    toggleStatus,
    driverName,
    setDriverName,
    setBookingType,
    setBookingId,
    bookingType,
  } = IndexUse();



  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);
  useEffect(() => {
    if (country?.data?.data) {
      const newIds = country?.data?.data?.map((d) => d.id);
      setAllChecked(newIds);
    }
  }, [country?.data]);

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const [id, setId] = useState("");

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const handleDelete = async (id) => {
    const success = await deleteData(id);
    setRDelete(false);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);
    await fetch();
    // if (success) setSuccess(true);
    // else setErr(true);
  };

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  const HandleDownload = async () => {
    // if (selectAllChecked.length == 0) {
    //   alert("Please Select Atleast One Record");
    // } else {
      try {
        await DOWNLOAD_EXCEL(
          "/admin/booking/download",
          selectAllChecked,
          "Booking List"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    // }
  };

  return (
    <>
      <section className="content_body section_box">
        <div className="top_title_sec">
          <div className="forms_section">
            <div className="row align-items-end">
              <div className="col-md-12">
                <Section_title title="Transport Bookings " alltotal="" />
              </div>
              {/* <div className="col-md-5 mb-3 ps-0">
                    <Table_search name={name} setName={setName} fetch={fetch} />
                </div> */}
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by Customer Name</label>
                <Form.Control
                  type="text"
                  placeholder="Enter First Name"
                  value={first_name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by Email</label>
                <Form.Control
                  type="text"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setemail(e.target.value)}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by Contact Number</label>
                <Form.Control
                  type="text"
                  placeholder="Enter Contact Number"
                  value={contact_no}
                  onChange={(e) => setcontact_no(e.target.value)}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by Driver Name</label>
                <Form.Control
                  type="text"
                  placeholder="Enter Driver Name"
                  value={driverName}
                  onChange={(e) => setDriverName(e.target.value)}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by From Date</label>
                <Form.Control
                  type="date"
                  placeholder="Enter From"
                  value={from}
                  onChange={(e) => {
                    setFrom(e.target.value);
                    handlePageChange(1);
                    setTo("");
                  }}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by To Date</label>
                <Form.Control
                  type="date"
                  placeholder="Enter To"
                  value={to}
                  onChange={(e) => {
                    setTo(e.target.value);
                    handlePageChange(1);
                  }}
                  min={from}
                />
              </div>
              <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
                <button
                  className="btn btn-danger "
                  onClick={() => {
                    setName("");
                    setemail("");
                    setcontact_no("");
                    setFrom("");
                    setTo("");
                    setDriverName("");
                    setBookingType("");
                    url.searchParams.delete("booking_id");
                    window.history.replaceState({}, "", url);
                    setBookingId("");
                    fetch();
                  }}
                >
                  Reset
                </button>
              </div>
              <div className="mb-3">
                {/* <CButton name="Reset" variant="danger" action={handleReset} /> */}
                {/* <CButton name="Add" variant="success" action={() => setAdd(true)} /> */}
                <button className="btn btn-success " onClick={HandleDownload}>
                  Download Excel
                </button>
              </div>{" "}
            </div>
          </div>
        </div>

        {/* <Add id={id} setId={setId} /> */}
        <div className="table-responsive">
          <div className="table_section theme_bg">
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    {/* <th>
                      <input
                        type="checkbox"
                        value="selectAll"
                        checked={allChecked.length === selectAllChecked.length}
                        onChange={handleChange}
                        id="selectAll"
                        className="me-1"
                      ></input>
                      Select
                    </th> */}
                    <th>S. no.</th>
                    <th>Customer First Name</th>
                    <th>Customer Contact No</th>
                    <th>Booking Type</th>
                    <th>Is Schedule</th>
                    <th>Driver Name</th>
                    <th>Driver Contact Number</th>
                    <th>Payment Type </th>
                    <th className="border-none-holder">Date</th>
                    <th className="border-none-holder">Verification Image</th>
                    <th>Charges Details </th>
                    <th>Booking Details </th>
                    <th>Drop Details </th>
                    <th>Show Rating </th>
                  </tr>
                </thead>
                <tbody>
                  {country?.data?.data?.length > 0 ? (
                    country?.data.data?.map((val, index) => (
                      <tr key={index}>
                        {/* <td>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            value={val?.id}
                            name="perselected"
                            checked={selectAllChecked.includes(val?.id)}
                            onChange={handleChange}
                            id="flexCheckDefault"
                          />
                        </td>{" "} */}
                        <td>
                          {(country?.data?.current_page - 1) *
                            country?.data?.per_page +
                            index +
                            1}
                        </td>
                        <td>{val?.User?.first_name || "-"}</td>
                        <td>{val?.User?.contact_no || "-"}</td>
                        <td>{val?.booking_type || "-"}</td>
                        <td>{val?.is_schedule ? "Yes" : "No" || "-"}</td>
                        <td>{val?.Driver?.first_name || "-"}</td>
                        <td>{val?.Driver?.contact_no || "-"}</td>
                        <td>{val?.PaymentType?.name || "-"}</td>
                        <td>
                          {new Date(val?.createdAt).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </td>
                        <td>
                          <img
                            src={IDS.IMG_URL + val?.verification_image}
                            alt="Verification"
                            style={{ width: "50px", height: "50px" }}
                          onClick={() => {
                            setModalImageShow(true);
                            setImage(val?.verification_image);
                          }}
                          />
                        </td>
                        <td>
                          <ul>
                            <li>
                              <b>Total Amount: </b>
                              {val?.amount || "-"}
                            </li>
                            <li>
                              <b>Actual Amount: </b>
                              {val?.actual_amount || "-"}
                            </li>
                            <li>
                              <b>Platform Fee: </b>
                              {val?.platform_fees || "-"}
                            </li>
                          </ul>
                        </td>
                        <td>
                          <Button
                            className="btn view-btn btn-sm"
                            onClick={() => {
                              setBookingDetails(val);
                              setDetailModalShow(true);
                            }}
                          >
                            {/* View */}
                            <FontAwesomeIcon icon={faEye} />
                          </Button>
                        </td>
                        <td>
                          <Button
                            className="btn view-btn btn-sm"
                            onClick={() => {
                              setDropDetails(val?.BookingDropDetails);
                              setModalShow(true);
                            }}
                          >
                            {/* View */}
                            <FontAwesomeIcon icon={faEye} />
                          </Button>
                        </td>
                        <td>
                          {val?.Rating ? (
                            <>
                              {Array.from({ length: 5 }, (_, i) => (
                                <span key={i}>
                                  {i < Math.floor(val.Rating.rating)
                                    ? "★"
                                    : "☆"}
                                </span>
                              ))}
                              <span className="ms-2">
                                ({val.Rating.rating})
                              </span>
                            </>
                          ) : (
                            <span className="text-danger">No Rating</span>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No Data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <Pagination_Holder
          onPageChange={country?.data?.current_page}
          totalPages={country?.data?.total_pages}
          handlePageChange={handlePageChange}
        />
      </section>

      <View_Booking_Modal
        show={detailModalShow}
        bookingdetails={bookingdetails}
        onHide={() => setDetailModalShow(false)}
      />

      <View_Modal
        show={modalShow}
        dropdetails={dropdetails}
        onHide={() => setModalShow(false)}
      />
      <View_img_Modal
        show={modalImageShow}
        image={image}
        onHide={() => setModalImageShow(false)}
      />
    </>
  );
};

export default Booking;
